
import Model from '../../component/ModelButton/Model';
import Typewriter from 'typewriter-effect';
import './Environment.css';
import '../../App.css';
import AOS from 'aos';


import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faAngleRight } from '@fortawesome/free-solid-svg-icons'


import producEau from '../../image/producEau.jpg'
import froid from '../../image/froid.jpg'
import farm from '../../image/farm.jpg'
import airco from '../../image/airco.jpg'
import ainn from '../../image/ainn.jpg'
import airno from '../../image/airno.jpg'







function Environment(){
    AOS.init();

    return(
     <div>

        <div className=" container-fluid bg-secondary pt-2 pt-lg-5 pb-2 mb-5">
              <div className="container py-5">
                <div className="row row-box align-items-center py-4">
                    <div className="col-md-6 text-center text-md-left">
                        <h1 className="mb-4 mb-md-0 text-white">Environment</h1>
                     </div>
                        <div className="col-md-6 text-center text-md-right">
                            <div className="d-inline-flex align-items-center">
                                <Link className="btn text-white" to="/">Home</Link>
                                <FontAwesomeIcon className="fas fa-angle-right text-white" icon={faAngleRight} />
                              
                                <Link className="btn text-white disabled" to="/Environment">Environment</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="container">
                <div className="row">
                    <div className=" col-md-3">
                        <img data-aos="fade-right" className="img1 aos-init aos-animate" src="https://www.ukconstructionmedia.co.uk/wp-content/uploads/environment-infrastructure-min-1024x576.jpg" alt=""/>
                     </div>
                            <div className="col-md-9">
                                
                                <p style={{marginTop:"70px"}} className="p-ses aos-init aos-animate" data-aos="fade-left">
                                   <Typewriter
                                    options={{
                                        delay:35
                                    }}
                                   onInit={(typewriter)=>{

                                    typewriter.typeString("We leverage our network of skilled engineers, scientists, auditors, planners and environmental specialists to assist clients to achieve their goals.We offer a broad range of integrated, practical and innovative services.").start();
                                   }}
                                   
                                   
                                   
                                   />
                                   
                                   <br/>
                                </p>
                            </div>
                 </div>
             </div>


             <div className="container service" id="Domaines-d’intervention" >
             <div className="row">
                 <div className="col-md-12 Pandingh2">
                    <h2 className="h2-ses" style={{textAlign:"center"}} >
                    Areas of intervention
                    </h2>
                 </div>
                 <div className="row">
                 <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={producEau} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                        <ul>
                            <li>
                            Reverse osmosis, nanofiltration, electrodialysis and ultrafiltration

                            </li>
                            <li>
                            Desalination and recovery of natural waters

                            </li>
                            <li>
                            Treatment and recovery of water discharge.

                            </li>
                        </ul>
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Water treatment</h3>
                    <Model
                    title ="Water treatment"
                    body={[" Reverse osmosis, nanofiltration, electrodialysis and ultrafiltration",<br/>,"Desalination and recovery of natural waters",<br/>,"Treatment and recovery of water discharge."]}
                    />                  
                      </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={froid} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                     <ul>
                         <li>
                         Energy recovery
                         </li>
                         <li>
                         Circular economy

                         </li>
                         <li>
                         Waste management

                         </li>
                         <li>
                             Recycling solutions
                         </li>
                     </ul>
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Waste treatment solutions</h3>
                    <Model
                    title ="Waste treatment solutions"
                    body={["Energy recovery",<br/>,"Circular economy",<br/>,"Waste management",<br/>,"Recycling solutions"]}
                    />                </div>
                    </div>
                    </div>
                    
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={farm} alt="no" />
                    <div className="service-overlay">
                    <p style={{marginTop:'40px'}}>
                         For better use of resources
                        <ul>
                         <li>
                         Predict and prevent plant diseases. 
                         </li>
                         <li>
                         Geolocate the treatments in the right place.
                         </li>
                         <li>
                         Position and control irrigation devices
                         </li>
                         <li>
                         Develop new agronomic practices.
                         </li>
                        </ul>

                                     </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Smart agriculture</h3>
                    <Model
                    title ="Smart agriculture"
                    body=" For better use of resources: Predict and prevent plant diseases ,  Geolocate the treatments in the right place , Position and control irrigation devices & Develop new agronomic practices. "
                    />
                    </div>
                    </div>
                    </div>
                    </div>
                    <div className="row">
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="100" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={airno} alt="rf" />
                    <div className="service-overlay">
                    <p>
                    MPEMI provides practical, science-based air quality, odour and noise management solutions. We consider sustainable practice and legislative demands on air, odour, and noise outcomes to help clients reach targets efficiently and reduce lifecycle costs.
                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3> Air and noise diagnosis 	</h3>
                    <Model
                    title ="Air and noise diagnosis "
                    body=" MPEMI provides practical, science-based air quality, odour and noise management solutions. We consider sustainable practice and legislative demands on air, odour, and noise outcomes to help clients reach targets efficiently and reduce lifecycle costs."
                    />             
                     </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="200" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={ainn} alt="dsq" />
                    <div className="service-overlay">
                    <p style={{marginTop:'40px'}}>
                    <ul>
                        <li>
                        Environmental site investigations

                        </li>
                        <li>
                        Contaminated land auditing

                        </li>
                        <li>
                        Contamination fate and transport modeling

                        </li>
                        <li>
                        Human health and ecological risk assessments

                        </li>
                        <li>
                        Feasibility Studies and Remedial Design

                        </li>
                    </ul>
                                         
                         </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>Contamination Assessment and Remediation </h3>
                    <Model
                    title ="Contamination Assessment and Remediation"
                    body="Environmental site investigations
                    Contaminated land auditing
                    Contamination fate and transport modeling
                    Human health and ecological risk assessments
                    Feasibility Studies and Remedial Design"
                    />            
                            </div>
                    </div>
                    </div>
                    <div className="col-lg-4 col-md-6 wow fadeInUp" data-aos={"fade-up"}  data-aos-delay="300" >
                    <div className="service-item">
                    <div className="service-img">
                    <img src={airco} alt="dsq" />
                    <div className="service-overlay">
                    <p>
                    We support organisations to reduce their environmental impact, including through implementing and improving their EMS whilst maintaining and achieving ISO 14001 certification.                    </p>
                    </div>
                    </div>
                    <div className="service-text">
                    <h3>ISO 14001</h3>
                    <Model
                    title ="ISO 14001"
                    body="We support organisations to reduce their environmental impact, including through implementing and improving their EMS whilst maintaining and achieving ISO 14001 certification."
                    />
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
                    
     </div>
    );
}

export default Environment;